import React from "react";
import styled from "styled-components";
import { colors } from "../../styles/variables";

interface IProps {
  id: string;
  placeholder: string;
  required: boolean
  className?: string
  onChange: (event: React.ChangeEvent) => void
}

const StyledInput = styled.input`
  width: 100%;
  height: 40px;
  background-color: transparent;
  font-size: 16px;
  padding: 4px 16px;
  border: 1px solid ${colors.gray300};
  -moz-border-radius: 0;
  -webkit-border-radius: 0;
  -webkit-appearance: none;
  border-radius: 0;
  outline: none;
  &::placeholder {
    color: ${colors.gray500};
  }
`;

const Input = ({ id, placeholder, required, className, onChange }: IProps) => {
  return <StyledInput type="text" onChange={onChange} placeholder={placeholder} id={id} required={required} className={className} />;
};

export default Input;
